'use strict'

const transitiontime = 125

// requires jQuery on page
export default function () {
  $('body').on('click touch', '.popup-actions-button .popup-actions-button__toggle', function(e) {
    $(this).next('.popup-actions-button__popup').fadeToggle(transitiontime)
  })

  $('body').on('click touch', function(e) {
    if(e.target.className != 'popup-actions-button__toggle'){
      $('.popup-actions-button__popup').fadeOut(transitiontime)
    } else {
      $('.popup-actions-button__popup').not(event.target.parentElement.children).fadeOut(transitiontime)
    }
  })
}
